<template>
  <component
    :is="productInfo.productBlockType || 'ProductUnfolded'"
    :id="productBlockId"
    :title="title"
    :content="content"
    :video="video"
    :placeholder="placeholder"
    :images="images"
    :items="productInfo.items"
    :nodes="productInfo.nodes"
    :additional-class="productBlockClass"
    :published-to="productInfo.publishedTo"
  ></component>
</template>

<script>
  import SystemIntro from '~/components/product/ProductBlock/SystemIntro.vue';
  import ProductUnfolded from '~/components/product/ProductBlock/ProductUnfolded.vue';
  import ProductCard from '~/components/product/ProductBlock/ProductCard.vue';
  import ProductOverview from '~/components/product/ProductBlock/ProductOverview.vue';
  import { privacyTypes } from '~/constants';

  export default {
    components: {
      SystemIntro,
      ProductUnfolded,
      ProductCard,
      ProductOverview
    },
    computed: {
      productBlockId() {
        return this.productInfo.id ? 'p-' + this.productInfo.id : '';
      },
      productBlockClass() {
        const classes = [];
        switch (this.productInfo.productBlockType) {
          case 'SystemIntro':
            classes.push('product-block_intro');
            break;
          case 'ProductUnfolded':
            classes.push('product-block_unfolded');
            break;
          case 'ProductCard':
            classes.push('product-block_card');
            break;
          case 'ProductOverview':
            classes.push('product-block_overview');
            break;
          default:
            classes.push('product-block_unfolded');
        }
        // Section-level internal/service modifier — drives the left borderline.
        // Mirrors Intro's introTypeClass so overview sections match the detail page.
        switch (Number(this.productInfo.publishedTo)) {
          case privacyTypes.INTERNAL:
            classes.push('product-block_internal');
            break;
          case privacyTypes.SERVICE:
            classes.push('product-block_service');
            break;
        }
        return classes.join(' ');
      },
      title() {
        return this.productInfo && this.productInfo.external && this.productInfo.external.title
          ? this.productInfo.external.title
          : this.productInfo && this.productInfo.internal && this.productInfo.internal.title
            ? this.productInfo.internal.title
            : this.productInfo && this.productInfo.title
              ? this.productInfo.title
              : '';
      },
      content() {
        let content = {};
        content.external = this.productInfo.external;
        content.internal = this.productInfo.internal;
        content.erpCode = this.productInfo.erpCode;
        content.serviceInfo = this.productInfo.serviceInfo;
        return content;
      },
      isResourcesPresent() {
        return this.productInfo.resources && this.productInfo.resources.length > 0;
      },
      video() {
        if (this.isResourcesPresent) {
          let video = this.productInfo.resources.filter((item) => {
            return item.mimeType && item.mimeType.indexOf('application/octet-stream') > -1 && item.fileName.split('.').pop() != 'dwg';
          });
          return video[0];
        }
      },
      placeholder() {
        if (this.isResourcesPresent) {
          let images = this.productInfo.resources.filter((item) => {
            return item.mimeType && item.mimeType.indexOf('image') > -1;
          });
          return images[0];
        }
      },
      images() {
        if (this.productInfo.resources && this.productInfo.resources.length) {
          let images = this.productInfo.resources.filter((item) => {
            return item.mimeType && item.mimeType.indexOf('image') > -1;
          });
          return images;
        }
      }
    },
    props: {
      productInfo: {
        default() {
          return {};
        },
        type: Object
      }
    }
  };
</script>
